/**
 * @generated SignedSource<<fba6f01363a1ace269d43a446cffe027>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnenrollEnrollClientInput = {
  clientMutationId?: string | null | undefined;
  enrollmentId: string;
  programId: string;
  startDate: string;
};
export type ChooseProgramEnrollDialogUnenrollEnrollMutation$variables = {
  input: UnenrollEnrollClientInput;
};
export type ChooseProgramEnrollDialogUnenrollEnrollMutation$data = {
  readonly unenrollEnrollClient: {
    readonly createdEnrollment: {
      readonly " $fragmentSpreads": FragmentRefs<"CoachClientCalendar_enrollment">;
    };
    readonly deletedEnrollmentId: string;
  } | null | undefined;
};
export type ChooseProgramEnrollDialogUnenrollEnrollMutation = {
  response: ChooseProgramEnrollDialogUnenrollEnrollMutation$data;
  variables: ChooseProgramEnrollDialogUnenrollEnrollMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedEnrollmentId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "utc",
  "value": true
},
v8 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChooseProgramEnrollDialogUnenrollEnrollMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnenrollEnrollClientPayload",
        "kind": "LinkedField",
        "name": "unenrollEnrollClient",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Enrollment",
            "kind": "LinkedField",
            "name": "createdEnrollment",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CoachClientCalendar_enrollment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChooseProgramEnrollDialogUnenrollEnrollMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnenrollEnrollClientPayload",
        "kind": "LinkedField",
        "name": "unenrollEnrollClient",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Enrollment",
            "kind": "LinkedField",
            "name": "createdEnrollment",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": "startDate(raw:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Program",
                "kind": "LinkedField",
                "name": "program",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageURL",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "activities",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(raw:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Component",
                    "kind": "LinkedField",
                    "name": "component",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "draft",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": "title(draft:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locked",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "iconName",
                            "storageKey": null
                          }
                        ],
                        "type": "ComponentIcon",
                        "abstractKey": "__isComponentIcon"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Enrollment",
                    "kind": "LinkedField",
                    "name": "enrollment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Program",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "startDateRaw",
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": "startDate(raw:true)"
              },
              {
                "alias": "startFromNow",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "fromNow"
                  },
                  (v7/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": "startDate(format:\"fromNow\",utc:true)"
              },
              {
                "alias": "startDateShort",
                "args": (v8/*: any*/),
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": "startDate(format:\"MMM DD, YYYY\",utc:true)"
              },
              {
                "alias": "endDateShort",
                "args": (v8/*: any*/),
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": "endDate(format:\"MMM DD, YYYY\",utc:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b53563a9695e07cb1e26fffca80f443",
    "id": null,
    "metadata": {},
    "name": "ChooseProgramEnrollDialogUnenrollEnrollMutation",
    "operationKind": "mutation",
    "text": "mutation ChooseProgramEnrollDialogUnenrollEnrollMutation(\n  $input: UnenrollEnrollClientInput!\n) {\n  unenrollEnrollClient(input: $input) {\n    deletedEnrollmentId\n    createdEnrollment {\n      ...CoachClientCalendar_enrollment\n      id\n    }\n  }\n}\n\nfragment CalendarComponentCard_component on Component {\n  title(draft: true)\n  type\n  status\n  locked\n  ...ComponentIcon_component\n}\n\nfragment ChangeEnrollmentStartDateDialog_enrollment on Enrollment {\n  id\n}\n\nfragment ClientCalendarProgramCard_enrollment on Enrollment {\n  id\n  startDateRaw: startDate(raw: true)\n  startFromNow: startDate(utc: true, format: \"fromNow\")\n  startDateShort: startDate(utc: true, format: \"MMM DD, YYYY\")\n  endDateShort: endDate(utc: true, format: \"MMM DD, YYYY\")\n  ...ClientSmallProgramCard_enrollment\n  ...ConfirmRemoveFromProgramDialog_enrollment\n  ...ChangeEnrollmentStartDateDialog_enrollment\n}\n\nfragment ClientSmallProgramCard_enrollment on Enrollment {\n  program {\n    name\n    imageURL\n    slug\n    id\n  }\n  client {\n    username\n    id\n  }\n}\n\nfragment CoachClientCalendarActivity_activity on Activity {\n  date(raw: true)\n  completed\n  component {\n    ...CalendarComponentCard_component\n    slug\n    type\n    id\n  }\n  enrollment {\n    client {\n      username\n      id\n    }\n    program {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment CoachClientCalendarEnrollment_enrollment on Enrollment {\n  program {\n    name\n    id\n  }\n  ...ClientCalendarProgramCard_enrollment\n}\n\nfragment CoachClientCalendar_enrollment on Enrollment {\n  id\n  startDate(raw: true)\n  program {\n    name\n    id\n  }\n  activities {\n    id\n    date(raw: true)\n    component {\n      type\n      id\n    }\n    ...CoachClientCalendarActivity_activity\n  }\n  ...CoachClientCalendarEnrollment_enrollment\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ConfirmRemoveFromProgramDialog_enrollment on Enrollment {\n  id\n  client {\n    displayName\n    id\n  }\n  program {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a26faf04604b70377695ee377208d53";

export default node;
